import { useMutation } from "@tanstack/react-query"

import { client } from "@/api"
import { useQueryClient } from "@tanstack/react-query"
import queryKeys from "@/api/queryKeys"

function useFavoriteEvent() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (eventId: number) =>
      client
        .post(`/events/favorite/${eventId}`)
        .then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.events._def,
      })
    },
  })
}
export default useFavoriteEvent
